import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Select from 'react-select';
import moment from 'moment';
import * as addressActions from 'modules/common/address/actions';
import * as ac from 'modules/common/address/constant';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'VARIABLES';

const fields = [
  'LOCATION_NAME',
  'TITLE_SITE',
  'ALTERNATE_MUNICIPALITY_NAME',
  'LGU_DISPLAY_NAME',
  'ALTERNATE_PROVINCE_NAME',
  'EMAIL_1',
  'EMAIL_2',
  'EMAIL_3',
  'EMAIL_4',
  'EMAIL_5',
  'TRUNK_LINE_1',
  'TRUNK_LINE_2',
  'TRUNK_LINE_3',
  'MAYORS_OFFICE_1',
  'MAYORS_OFFICE_2',
  'MAYORS_OFFICE_3',
  'OFFICE_TRUNK_LINE_1',
  'OFFICE_TRUNK_LINE_2',
  'OFFICE_TRUNK_LINE_3',
  'OFFICE_TRUNK_LINE_4',
  'OFFICE_TRUNK_LINE_5',
  'CONTACT_PLDT',
  'CONTACT_SMART',
  'CONTACT_GLOBE',
  'CONTACT_SUN',
  'REGION_CODE',
  'REGION_NAME',
  'ALTERNATE_REGION_NAME',
  'PROVINCE_CODE',
  'PROVINCE_NAME',
  'MUNICIPALITY_CODE',
  'MUNICIPALITY_NAME',
  'IS_CITY',
  'SYSTEM_STATUS',
  'LIVE_DATE',
  'E_NEWS',
  'BPLS_NEW',
  'BPLS_RENEWAL',
  'BPLS_QUARTERLY',
  'BPLS_DELINQUENT',
  'BPLS_CHANGE_REQUEST',
  'BPLS_RETIREMENT',
  'CIVIL_REGISTRY_BIRTH_CERTIFICATE',
  'CIVIL_REGISTRY_DEATH_CERTIFICATE',
  'CIVIL_REGISTRY_MARRIAGE_CERTIFICATE',
  'CEDULA_INDIVIDUAL',
  'CEDULA_CORPORATION',
];

const fields_core = ['TITLE', 'CITIZEN_ID', 'ALTERNATE_MUNICIPALITY_NAME'];

function Variables({
  getList,
  createInput,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  createCheckbox,
  createSelect,
  getRegions,
  getProvinces,
  getMunicipalities,
  regions,
  provinces,
  municipalities,
}) {
  const formRegionCode = _.get(formData, 'REGION_CODE');
  const formProvinceCode = _.get(formData, 'PROVINCE_CODE');
  const formMunicipalityCode = _.get(formData, 'MUNICIPALITY_CODE');

  const regionOptions = useMemo(() => {
    if (!regions || isEmpty(regions)) return [];
    return regions.map((r) => {
      const rAttr = r.attributes;
      return {
        label: `${rAttr.name}`,
        value: rAttr.code,
      };
    });
  }, [regions]);
  const provinceOptions = useMemo(() => {
    if (!provinces || isEmpty(provinces) || !formRegionCode) return [];
    return provinces.map((r) => {
      const rAttr = r.attributes;
      return {
        label: `${rAttr.code} - ${rAttr.name}`,
        value: rAttr.code,
      };
    });
  }, [provinces, formRegionCode]);

  const municipalityOptions = useMemo(() => {
    if (!municipalities || isEmpty(municipalities) || !formProvinceCode)
      return [];
    return municipalities.map((r) => {
      const rAttr = r.attributes;
      return {
        label: `${rAttr.code} - ${rAttr.name}`,
        value: rAttr.code,
      };
    });
  }, [municipalities, formProvinceCode]);

  useEffect(() => {
    getList({ type: CMS_TYPE });
    getRegions('regions');
  }, []);

  useEffect(() => {
    if (!formRegionCode) return;
    getProvinces('provinces', formRegionCode);
  }, [formRegionCode]);

  useEffect(() => {
    if (!formProvinceCode) return;
    getMunicipalities('municipalities', formRegionCode, formProvinceCode);
  }, [formProvinceCode]);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
      live_date: moment(_.get(item, 'attributes.live_date')).format('MM/DD/YYYY') || '',
    });
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        body: JSON.stringify(_.pick(formData, [...fields, ...fields_core])),
      });
    }

    return create({
      body: JSON.stringify(_.pick(formData, [...fields, ...fields_core])),
    });
  };

  const handleDateChange =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  useEffect(() => {
    if (_.get(formData, 'SYSTEM_STATUS') !== 'LIVE') {
      setFormData({
        ...formData,
        LIVE_DATE: '',
      });
    }
  }, [_.get(formData, 'SYSTEM_STATUS')]);

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  const getDisplay = (isValid) => {
    if (!isValid) {
      return (
        <span className="text-danger">
          <i>Required</i>
        </span>
      );
    }
    return (
      <small className="text-success">
        <i className="fa fa-check" />
      </small>
    );
  };

  const validation = (field) => {
    switch (field) {
      case 'REGION_CODE':
        return getDisplay(formRegionCode);

      case 'PROVINCE_CODE':
        return getDisplay(formProvinceCode);

      case 'MUNICIPALITY_CODE':
        return getDisplay(formMunicipalityCode);

      default:
        return getDisplay(true);
    }
  };

  const onChangeAddress = (key) => (e) => {
    const { label, value } = e;
    const trimmedLabel = label.replace(/^[\d\-\s]+/, '');
    const hasCityPrefix = /^CITY OF\s*/i.test(trimmedLabel);

    setFormData({
      ...formData,
      [key]: value,
      ...(key === 'REGION_CODE' && {
        REGION_NAME: trimmedLabel,
        PROVINCE_NAME: '',
        PROVINCE_CODE: '',
        MUNICIPALITY_NAME: '',
        MUNICIPALITY_CODE: '',
      }),
      ...(key === 'PROVINCE_CODE' && {
        PROVINCE_NAME: trimmedLabel,
        MUNICIPALITY_NAME: '',
        MUNICIPALITY_CODE: '',
      }),
      ...(key === 'MUNICIPALITY_CODE' && { MUNICIPALITY_NAME: trimmedLabel }),
      ...(key === 'MUNICIPALITY_CODE' && { IS_CITY: hasCityPrefix ? 1 : 0 }),
    });
  };

  const formatMunicipalityNameByType = (
    municipalityName,
    isCity,
  ) => {
    if (!municipalityName) return municipalityName;
    if (/^City of$/i.test(_.trim(municipalityName))) return municipalityName;

    const hasCityPrefix = /^CITY OF\s*/i.test(municipalityName);
    const normalizedName = municipalityName
      .replace(/^Municipality of\s*/i, '')
      .replace(/^City of\s*/i, '')
      .trim();
    const capitalizedNormalizedName = normalizedName
      .toLowerCase()
      .replace(/\b\w/g, (letter) => letter.toUpperCase());

    if (isCity && hasCityPrefix) {
      return `City of ${capitalizedNormalizedName}`;
    }

    if (isCity && !hasCityPrefix) {
      return `City of ${capitalizedNormalizedName}`;
    }

    if (!isCity && hasCityPrefix) {
      return `Municipality of ${capitalizedNormalizedName}`;
    }

    if (!isCity && !hasCityPrefix) {
      return `Municipality of ${capitalizedNormalizedName}`;
    }

    return `${municipalityName}`;
  };

  useEffect(() => {
    const municipalityName = _.get(formData, 'MUNICIPALITY_NAME', '');
    const isCity = Boolean(_.get(formData, 'IS_CITY'));
    const updatedMunicipalityName = formatMunicipalityNameByType(
      municipalityName,
      isCity,
    );

    if (updatedMunicipalityName === municipalityName) return;

    setFormData({
      ...formData,
      MUNICIPALITY_NAME: updatedMunicipalityName,
    });
  }, [
    _.get(formData, 'IS_CITY'),
    _.get(formData, 'MUNICIPALITY_NAME'),
  ]);

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        {createHidden({ key: 'id' }, { placeholder: '' })}
        <div className="row">
          <div className="col-12">
            <label className="cms-label my-2">SITE: </label>
            <hr className="hr" />
            <div className="row">
              <div className="col-4 form-group group-cms-color">
                <label htmlFor="REGION_CODE" className='form-label d-flex align-items-center m-0 mr-1'>
                  Region {validation('REGION_CODE')}
                </label>
                <Select
                  name="REGION_CODE"
                  options={regionOptions}
                  onChange={onChangeAddress('REGION_CODE')}
                  value={regionOptions.find(
                    (option) => option.value === formRegionCode
                  )}
                />
              </div>
              <div className="col-4 form-group group-cms-color">
                {createInput(
                  { key: 'ALTERNATE_REGION_NAME', label: 'Region Alternate Name' },
                  { type: 'text' }
                )}
              </div>
              <div className="col-4 form-group group-cms-color">
                <label htmlFor="REGION_CODE" className='form-label d-flex align-items-center m-0 mr-1'>
                  Region Geocode
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="REGION_CODE"
                  name="REGION_CODE"
                  value={_.get(formData, 'REGION_CODE', '')}
                  onChange={() => {}}
                  disabled
                />
              </div>
              <div className="col-4 form-group group-cms-color">
                <label htmlFor="PROVINCE_CODE" className='form-label d-flex align-items-center m-0 mr-1'>
                  Province {validation('PROVINCE_CODE')}
                </label>
                <Select
                  name="PROVINCE_CODE"
                  options={provinceOptions}
                  onChange={onChangeAddress('PROVINCE_CODE')}
                  isDisabled={!formRegionCode}
                  value={
                    formProvinceCode
                      ? provinceOptions.find(
                          (option) => option.value === formProvinceCode
                        )
                      : null
                  }
                />
              </div>
              <div className="col-4 form-group group-cms-color">
                {createInput(
                  {
                    key: 'ALTERNATE_PROVINCE_NAME',
                    label: 'Province Alternate Name',
                  },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-4 form-group group-cms-color">
                <label htmlFor="PROVINCE_CODE" className='form-label d-flex align-items-center m-0 mr-1'>
                  Province Geocode
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="PROVINCE_CODE"
                  name="PROVINCE_CODE"
                  value={_.get(formData, 'PROVINCE_CODE', '')}
                  onChange={() => {}}
                  disabled
                />
              </div>
              <div className="col-4 form-group group-cms-color">
                <label htmlFor="MUNICIPALITY_CODE" className='form-label d-flex align-items-center m-0 mr-1'>
                  City/Municipality {validation('MUNICIPALITY_CODE')}
                </label>
                <Select
                  name="MUNICIPALITY_CODE"
                  options={municipalityOptions}
                  onChange={onChangeAddress('MUNICIPALITY_CODE')}
                  isDisabled={!formProvinceCode}
                  value={
                    formMunicipalityCode
                      ? municipalityOptions.find(
                          (option) => option.value === formMunicipalityCode
                        )
                      : null
                  }
                />
              </div>
              <div className="col-4 form-group group-cms-color">
                {createInput(
                  { key: 'ALTERNATE_MUNICIPALITY_NAME', label: 'City/Municipality Alternate Name' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-4 form-group group-cms-color">
                <label htmlFor="MUNICIPALITY_CODE" className='form-label d-flex align-items-center m-0 mr-1'>
                  City/Municipality Geocode
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="MUNICIPALITY_CODE"
                  name="MUNICIPALITY_CODE"
                  value={_.get(formData, 'MUNICIPALITY_CODE', '')}
                  onChange={() => {}}
                  disabled
                />
              </div>
              <div className="col-4 group-cms-color form-input-group d-flex">
                {createCheckbox(
                  { key: 'IS_CITY', label: 'IS_CITY' },
                  { className: 'd-flex align-items-center align-self-center' }
                )}
              </div>
              <div className="col-4 form-group group-cms-color">
                {createInput(
                  { key: 'TITLE_SITE', label: 'Site Title' },
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-4 form-group group-cms-color">
                {createSelect(
                  { key: 'SYSTEM_STATUS', label: 'SYSTEM_STATUS' },
                  [
                    {
                      label: 'LIVE',
                      value: 'LIVE',
                    },
                    {
                      label: 'TEST',
                      value: 'TEST',
                    },
                    {
                      label: 'TRAINING',
                      value: 'TRAINING',
                    },
                  ],
                  { required: true, type: 'text' }
                )}
              </div>
              <div className="col-4 form-group group-cms-color">
                <label className="form-label d-flex align-items-center m-0 mr-1">
                  LIVE_DATE
                </label>
                <DateInputPicker
                  className="form-control"
                  onChange={handleDateChange('LIVE_DATE')}
                  value={_.get(formData, 'LIVE_DATE') || ''}
                  disabled={_.get(formData, 'SYSTEM_STATUS') !== 'LIVE'}
                />
              </div>
              <div className="col-4 form-group pt-3">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="eNews"
                    name="E_NEWS"
                    checked={_.get(formData, 'E_NEWS', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="eNews"
                  >
                    E-NEWS
                  </label>
                </div>
              </div>

              <hr className="hr mx-3" />
              <div className="col-12 form-group group-cms-color">
                <b>BPLS MODULES</b>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="bplsNew"
                    name="BPLS_NEW"
                    checked={_.get(formData, 'BPLS_NEW', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="bplsNew"
                  >
                    New
                  </label>
                </div>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="bplsRenewal"
                    name="BPLS_RENEWAL"
                    checked={_.get(formData, 'BPLS_RENEWAL', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="bplsRenewal"
                  >
                    Renewal
                  </label>
                </div>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="bplsQuarterly"
                    name="BPLS_QUARTERLY"
                    checked={_.get(formData, 'BPLS_QUARTERLY', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="bplsQuarterly"
                  >
                    Quarterly
                  </label>
                </div>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="bplsDelinquent"
                    name="BPLS_DELINQUENT"
                    checked={_.get(formData, 'BPLS_DELINQUENT', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="bplsDelinquent"
                  >
                    Delinquent
                  </label>
                </div>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="bplsChangeRequest"
                    name="BPLS_CHANGE_REQUEST"
                    checked={_.get(formData, 'BPLS_CHANGE_REQUEST', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="bplsChangeRequest"
                  >
                    Change Request
                  </label>
                </div>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="bplsRetirement"
                    name="BPLS_RETIREMENT"
                    checked={_.get(formData, 'BPLS_RETIREMENT', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="bplsRetirement"
                  >
                    Retirement
                  </label>
                </div>
              </div>
              <div className="col-12 form-group group-cms-color pt-3">
                <b>CIVIL REGISTRY MODULES</b>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="civilRegistryBirthCertificate"
                    name="CIVIL_REGISTRY_BIRTH_CERTIFICATE"
                    checked={_.get(formData, 'CIVIL_REGISTRY_BIRTH_CERTIFICATE', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="civilRegistryBirthCertificate"
                  >
                    Birth Certificate
                  </label>
                </div>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="civilRegistryDeathCertificate"
                    name="CIVIL_REGISTRY_DEATH_CERTIFICATE"
                    checked={_.get(formData, 'CIVIL_REGISTRY_DEATH_CERTIFICATE', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="civilRegistryDeathCertificate"
                  >
                    Death Certificate
                  </label>
                </div>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="civilRegistryMarriageCertificate"
                    name="CIVIL_REGISTRY_MARRIAGE_CERTIFICATE"
                    checked={_.get(formData, 'CIVIL_REGISTRY_MARRIAGE_CERTIFICATE', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="civilRegistryMarriageCertificate"
                  >
                    Marriage Certificate
                  </label>
                </div>
              </div>
              <div className="col-12 form-group group-cms-color pt-3">
                <b>CEDULA MODULES</b>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="cedulaIndividual"
                    name="CEDULA_INDIVIDUAL"
                    checked={_.get(formData, 'CEDULA_INDIVIDUAL', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="cedulaIndividual"
                  >
                    Individual
                  </label>
                </div>
              </div>
              <div className="col-4 form-group">
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="cedulaCorporation"
                    name="CEDULA_CORPORATION"
                    checked={_.get(formData, 'CEDULA_CORPORATION', '')}
                    onChange={onCheck}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="cedulaCorporation"
                  >
                    Corporation
                  </label>
                </div>
              </div>
              <hr className="hr mx-3" />
              <div className="col-12 form-group group-cms-color pt-3">
                <b>EMAIL_ADDRESS</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'EMAIL_1', label: 'EMAIL_1' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'EMAIL_2', label: 'EMAIL_2' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'EMAIL_3', label: 'EMAIL_3' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>TRUNK_LINE</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'TRUNK_LINE_1', label: 'TRUNK_LINE_1' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'TRUNK_LINE_2', label: 'TRUNK_LINE_2' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'TRUNK_LINE_3', label: 'TRUNK_LINE_3' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>MAYORS_OFFICE</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'MAYORS_OFFICE_1', label: 'MAYORS_OFFICE_1' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'MAYORS_OFFICE_2', label: 'MAYORS_OFFICE_2' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'MAYORS_OFFICE_3', label: 'MAYORS_OFFICE_3' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>OFFICE_TRUNK_LINE</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'OFFICE_TRUNK_LINE_1', label: 'OFFICE_TRUNK_LINE_1' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'OFFICE_TRUNK_LINE_2', label: 'OFFICE_TRUNK_LINE_2' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'OFFICE_TRUNK_LINE_3', label: 'OFFICE_TRUNK_LINE_3' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'OFFICE_TRUNK_LINE_4', label: 'OFFICE_TRUNK_LINE_4' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'OFFICE_TRUNK_LINE_5', label: 'OFFICE_TRUNK_LINE_5' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-12 form-group group-cms-color">
                <b>RESCUE</b>
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'CONTACT_PLDT', label: 'CONTACT_PLDT' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'CONTACT_SMART', label: 'CONTACT_SMART' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'CONTACT_GLOBE', label: 'CONTACT_GLOBE' },
                  { required: false, type: 'text' }
                )}
              </div>
              <div className="col-6 form-group group-cms-color">
                {createInput(
                  { key: 'CONTACT_SUN', label: 'CONTACT_SUN' },
                  { required: false, type: 'text' }
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
        </div>
      </form>
    </div>
  );
}

Variables.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  getRegions: PropTypes.instanceOf(Function).isRequired,
  getProvinces: PropTypes.instanceOf(Function).isRequired,
  getMunicipalities: PropTypes.instanceOf(Function).isRequired,
  regions: PropTypes.instanceOf(Array).isRequired,
  provinces: PropTypes.instanceOf(Array).isRequired,
  municipalities: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => {
  const regions = _.get(api, `${ac.GET_REGIONS}/regions.list`, []);
  const provinces = _.get(api, `${ac.GET_PROVINCES}/provinces.list`, []);
  const municipalities = _.get(
    api,
    `${ac.GET_MUNICIPALITIES}/municipalities.list`,
    []
  );
  return {
    item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
    regions,
    provinces,
    municipalities,
  };
};

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, { ...actions, ...addressActions }),
]);

export default enhance(Variables);
